/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function SelectionForeground(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" opacity={0.1} />
      <Path d="M64,216a8.00008,8.00008,0,0,1-8,8H48a16.01833,16.01833,0,0,1-16-16v-8a8,8,0,0,1,16,0v8h8A8.00008,8.00008,0,0,1,64,216Zm48-8H96a8,8,0,0,0,0,16h16a8,8,0,0,0,0-16ZM40,168a8.00008,8.00008,0,0,0,8-8V144a8,8,0,0,0-16,0v16A8.00008,8.00008,0,0,0,40,168Zm128,24a8.00008,8.00008,0,0,0-8,8v8h-8a8,8,0,0,0,0,16h8a16.01833,16.01833,0,0,0,16-16v-8A8.00008,8.00008,0,0,0,168,192Zm0-80a8.00008,8.00008,0,0,0,8-8V96a16.01833,16.01833,0,0,0-16-16h-8a8,8,0,0,0,0,16h8v8A8.00008,8.00008,0,0,0,168,112ZM56,80H48A16.01833,16.01833,0,0,0,32,96v8a8,8,0,0,0,16,0V96h8a8,8,0,0,0,0-16ZM207.999,31.99414h-112a16.01833,16.01833,0,0,0-16,16V88a8.00009,8.00009,0,0,0,8,8H112a8,8,0,0,0,0-16H95.999V47.99414h112v112H176V144a8,8,0,0,0-16,0v24a8.00008,8.00008,0,0,0,8,8c.03918,0,.0769-.00537.116-.00586H207.999a16.01833,16.01833,0,0,0,16-16v-112A16.01833,16.01833,0,0,0,207.999,31.99414Z" />
    </Svg>
  );
}

export default SelectionForeground;
